export const SLIDE_ID = 'Slide';
